// extracted by mini-css-extract-plugin
export default {"container":"theme_container__SV-Fl","title":"theme_title__box8G","description":"theme_description__WUgky"};